import React from 'react';
import Image from 'next/image';
// import {
//   CalendarFillIcon,
//   EyeFillIcon,
//   Profile,
//   RightArrowFillIcon,
// } from "@/src/Asset";
import Link from 'next/link';
import { formatDate } from '@/utils/formatDate';

const TrendingBlog = ({ topBlogs }: any) => {
  return (
    <section className="my-5 w-full md:my-10">
      <h2 className="font-montserrat text-2xl font-semibold text-primary underline underline-offset-2">
        Trending Blogs
      </h2>
      <div className="hide-scrollbar flex justify-items-center gap-2 overflow-auto sm:grid sm:grid-cols-2 sm:gap-5 md:grid-cols-2 xl:grid-cols-4">
        {topBlogs?.results?.slice(0, 8)?.map((blog: any) => (
          <div
            key={blog?.id}
            className="col-span-1 row-span-1 my-5 min-w-80 rounded-lg border font-montserrat sm:min-w-fit"
          >
            <Image
              src={blog?.featured_image?.url ?? ''}
              width={400}
              height={260}
              alt={blog?.blog_title ?? 'blog title'}
              className="h-40 w-full rounded-lg border object-fill sm:h-52"
            />
            <div className="mt-1 flex items-center px-2 text-sm font-light">
              <div className="flex items-center gap-x-1">
                {/* <CalendarFillIcon className="scale-75" />{" "} */}
                {formatDate(blog?.updatedAt, true)}
              </div>
              <div className="mx-4 h-3 w-px bg-gray-400"></div>
              <div className="flex items-center gap-x-1">
                {/* <EyeFillIcon className="scale-90" /> */}
                <p className="text-sm"> {blog?.view_count ?? '928'}</p>
              </div>
            </div>
            <div className="mt-3 px-2">
              <Link href={`/blogs/${blog?.blog_url}`} className="line-clamp-2 font-inter text-sm text-tertiary">
                {blog?.blog_title}
              </Link>
              {/* <p className="text-sm line-clamp-2 text-gray-500">
                {blog?.description || blog?.excerpt}
              </p> */}
            </div>
            <div className="mb-2 mt-4 flex items-center justify-between gap-x-2 px-2">
              <div className="flex items-center gap-x-2">
                {blog?.updated_by_user?.profile_picture?.url || blog?.created_by_user?.profile_picture?.url ? (
                  <Image
                    src={blog?.updated_by_user?.profile_picture?.url ?? blog?.created_by_user?.profile_picture?.url}
                    alt={blog?.updated_by_user?.name ?? "user-name"}
                    className="size-8 rounded-full bg-gray-100 object-cover"
                    width={40}
                    height={40}
                  />
                ) : null}
                <div className="flex min-h-[40px] flex-col justify-center">
                  <p className="text-sm font-semibold text-slate-700">
                    {blog?.updated_by_user?.name ?? blog?.created_by_user?.name ?? blog?.author_name ?? 'Tanya Verma'}
                  </p>
                  <p className="line-clamp-1 text-[10px] font-medium text-slate-700">
                    {blog?.updated_by_user?.designation ??
                      blog?.created_by_user?.designation ??
                      blog?.author_name ??
                      'Tanya Verma'}
                  </p>
                </div>
              </div>
              <Link
                href={`/blogs/${blog?.blog_url}`}
                className="mr-2 flex min-w-[120px] items-center gap-x-2 rounded-md bg-tertiary py-1.5 pl-4 pr-2 text-center text-[0.77rem] text-white duration-200 hover:scale-105"
              >
                Read More
                {/* <RightArrowFillIcon className="scale-90" /> */}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrendingBlog;
